import type { Device } from '../types/api';
import type { DeviceFilters } from '../components/devices/FilterPanel';

/**
 * Apply the client-side {@link DeviceFilters} (status, registration status,
 * client version, outdated, SSH tunnel) on top of the server-filtered device
 * list. Returns a new array; the input is not mutated.
 */
export const applyDeviceFilters = (
  devices: Device[],
  filters: DeviceFilters,
): Device[] => {
  let data = devices;

  if (filters.status && filters.status.length > 0) {
    data = data.filter(device => filters.status!.includes(device.status));
  }

  if (filters.registrationStatus && filters.registrationStatus.length > 0) {
    data = data.filter(
      device =>
        device.registrationStatus &&
        filters.registrationStatus!.includes(device.registrationStatus),
    );
  }

  if (filters.clientVersion && filters.clientVersion.length > 0) {
    data = data.filter(
      device =>
        device.clientVersion &&
        filters.clientVersion!.includes(device.clientVersion),
    );
  }

  if (filters.isOutdated) {
    // Treat anything other than the latest version as outdated.
    // TODO: replace the hardcoded version once the API exposes the latest one.
    data = data.filter(
      device => device.clientVersion && device.clientVersion !== '1.0.0',
    );
  }

  if (filters.hasSSHTunnel !== undefined) {
    data = data.filter(device =>
      filters.hasSSHTunnel ? device.ssh?.tunnelActive : !device.ssh?.tunnelActive,
    );
  }

  return data;
};
